var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex-1 w-4 h-2 mt-4 mx-2 mb-0 rounded-full overflow-hidden transition-colors duration-200 ease-out hover:bg-orange-600 focus:outline-none",class:{
    'bg-orange-400': _vm.isActive,
    'bg-orange-200': !_vm.isActive,
  },on:{"click":_vm.move}})}
var staticRenderFns = []

export { render, staticRenderFns }